import React, { useState, useEffect } from 'react';
import axios from 'axios';


function ClientTab({ caseId }) {
  const [clients, setClients] = useState([]); // State to store clients data
  const [showForm, setShowForm] = useState(false); // State to toggle form visibility

  // Fetch clients associated with the given caseId
  const fetchClients = async () => {
    const token = localStorage.getItem("token");

    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/client/case/${caseId}`,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      setClients(res.data); // Set fetched clients to the state
    } catch (error) {
      console.error('Error fetching clients:', error);
    }
  };

  // Run fetchClients whenever caseId changes or the component mounts
  useEffect(() => {
    if (caseId) fetchClients(); // Fetch clients only if caseId is available
  }, [caseId]);

  // Delete a client by ID
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this client?")) {
      try {
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/client/${id}`);
        alert("Client deleted.");
        fetchClients(); // Refresh the clients list after deletion
      } catch (err) {
        console.error("Error deleting client:", err);
        alert("Failed to delete client.");
      }
    }
  };

  return (
    <div className="space-y-4">
  
    

      {/* Display the list of clients */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        {clients.map((client) => (
          <div
            key={client._id}
            className="bg-white p-4 border rounded shadow flex justify-between items-start"
          >
            <div>
              <h3 className="text-lg font-bold">{client.clientName}</h3>
              <p><strong>Email:</strong> {client.Email || '—'}</p>
              <p><strong>Phone:</strong> {client.contact || '—'}</p>
              <p><strong>Company:</strong> {client.company || '—'}</p>
              <p><strong>Address:</strong> {client.building}, {client.street}, {client.city} - {client.pincode}</p>
            </div>

           
          </div>
        ))}
      </div>
    </div>
  );
}

export default ClientTab;
